import { parsePurl } from "@sscs/utils";
import { SupportedPurlImportOssCommunity } from "Types";

// We want this to result with a TS error if there is a Community that's not tranformed
export const SUPPORTED_PURL_IMPORT_COMMUNITY_TO_PURL_TYPE: Record<
  SupportedPurlImportOssCommunity,
  string
> = {
  rubygems: "gem",
  npm: "npm",
  nuget: "nuget",
  pypi: "pypi",
  vscode: "vsx",
  psgallery: "psgallery",
  maven: "maven",
};

export const doesUrlSupportsAuth = (url: string): boolean => {
  if (!url) return false;

  try {
    const purl = parsePurl(url);

    // OSS communities harvest only publicly available packages, thus do not support auth
    return !Object.values(
      SUPPORTED_PURL_IMPORT_COMMUNITY_TO_PURL_TYPE,
    ).includes(purl.type);
  } catch {
    // not a purl, we assume auth is supported
  }

  return true;
};
